import React from 'react';
import PrimaryStage from 'commonComponents/Stages/PrimaryStage/PrimaryStage';
import Mission from './Mission/Mission';
import Numbers from 'commonComponents/Numbers/Numbers';
import Executives from './Executives/Executives';
import WunderAgents from './WunderAgents/WunderAgents';
import OurEmployees from 'commonComponents/OurEmployees/OurEmployees';
import Positions from './Positions/Positions';
import EmployeePhoto from 'oldAssets/images/team/UmutKeskin.webp';
import styles from '../pages.module.scss';

const WunderAgentsContext = React.createContext();

const TeamPage = ({
  mission,
  banner,
  stats,
  management,
  managers,
  wunderagents,
  departments,
  employees,
  positions
}) => {
  const numbers = [30, 35, 11];

  return (    
    <div className={ styles.Page }>
      <PrimaryStage { ...banner } pageName="team" />
      <Mission { ...mission } />
      <Numbers stats={ stats.map((item, i) => ({ number: item.number || numbers[i], 
        caption: item.caption })) }
      />
      <WunderAgentsContext.Provider value={ wunderagents }>
        <Executives { ...management } managers={ managers } />
        <WunderAgents departments={ departments } />
      </WunderAgentsContext.Provider>
      <OurEmployees { ...employees } photo={ EmployeePhoto } />
      <Positions { ...positions } />
    </div>
  );
};

export default TeamPage;

export { WunderAgentsContext };
